(function() {
  'use strict';

  // Debug flag - set to true to enable debug logging
  const DEBUG = false;

  // Debug log function - only logs when DEBUG is true
  const debugLog = (...args) => {
    if (DEBUG) {
      console.log(...args);
    }
  };

  const logDebugJson = (json) => {
    if (DEBUG) {
      console.log('logDebugJson', json);
      console.log(JSON.stringify(json, null, 2));
    }
  };

  const ensureGlobal = () => {
    if (!window.RebuyCustom) window.RebuyCustom = {};
    if (!window.RebuyCustom.byWidgetId) window.RebuyCustom.byWidgetId = {};
    if (!window.RebuyCustom._lastHtml) window.RebuyCustom._lastHtml = {};
    if (!window.RebuyCustom.allowedWidgetIds) window.RebuyCustom.allowedWidgetIds = {};
    return window.RebuyCustom;
  };

  // Helper function to get translation strings
  const getTranslation = (key, fallback = '') => {
    try {
      // Try variantStrings first (for addToCart, soldOut, preOrder, etc.)
      if (window.theme?.variantStrings && window.theme.variantStrings[key]) {
        return window.theme.variantStrings[key];
      }
      // Try strings.product (for view_details, release_date, etc.)
      if (window.theme?.strings?.product && window.theme.strings.product[key]) {
        return window.theme.strings.product[key];
      }
      // Try direct access with underscore (for release_date -> release_date)
      const underscoreKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
      if (window.theme?.strings?.product && window.theme.strings.product[underscoreKey]) {
        return window.theme.strings.product[underscoreKey];
      }
    } catch (err) {
      debugLog('[Rebuy] getTranslation error:', err);
    }
    return fallback;
  };

  const getProductClassification = (product) => {
    const variants = Array.isArray(product?.variants) ? product.variants : [];

    const countdownValue = product?.metafields?.theme?.countdown;
    if (countdownValue != null && countdownValue !== '') {
      try {
        const countdownDate = new Date(countdownValue);
        const countdownUnix = countdownDate.getTime();
        const nowUnix = Date.now();
        if (countdownUnix > nowUnix) {
          return 'pre-order';
        }
      } catch (e) {
        console.warn('[Rebuy] Invalid countdown date:', countdownValue, e);
      }
    }

    if (variants.length === 2) {
      const titles = variants.map(v => (v?.title || '').trim().toUpperCase());
      if (titles.includes('PRE-OWNED') && titles.includes('NEW')) return 'preowned-new';
      return 'two-variants';
    }

    if (variants.length > 2) {
      return 'multiple';
    }

    return 'default';
  };

  const parseWidgetInfo = (widget) => {
    try {
      if (!widget || !widget.data) return;

      const widgetTitle = widget?.data?.settings?.language?.title || null;
      const g = ensureGlobal();
      const widgetId = widget?.data?.id || widget?.id || widget?.data?.widget_id;
      const widgetType = widget?.data?.settings?.type || null;

      if (widgetTitle === 'Frequently Bought Together') {
        if (widgetId != null) {
          const widgetEl = document.querySelector(`[data-rebuy-id="${widgetId}"]`);
          widgetEl.classList.add('rebuy-custom-frequently-bought-together-ui');
        }
        debugLog(`[Rebuy] Products widget id ${widgetId}:`, widget);

        return;
      }

      if (widgetTitle !== 'Similar Products' && widgetType !== 'product') {
        debugLog(`[Rebuy] Similar Products widget id ${widgetId}:`, widget);
        return;
      }


      const products = Array.isArray(widget.data.products) ? widget.data.products : [];
      if (!products.length) return;

      const classified = products.map(p => ({
        ...p,
        classification: getProductClassification(p)
      }));
      if (widgetId != null) {
        const prev = g.byWidgetId[widgetId] || {};
        g.byWidgetId[widgetId] = {
          ...prev,
          title: widgetTitle,
          products,
          classified
        };
        g.allowedWidgetIds[widgetId] = true;
      }

      g.similarProducts = classified;
      g.similarProductsRaw = products;
    } catch (err) {
      console.error('[Rebuy] parseWidgetInfo error:', err);
    }
  };

  const getWidgetFromEvent = (e) => {
    const d = e && e.detail ? e.detail : {};
    return d.widget || d.el || d.element || d.container || d;
  };

  const logAndParse = (name) => (e) => {
    if (window.Rebuy && window.Rebuy) {
      debugLog(`[Rebuy] Rebuy object found:`, window.Rebuy);
    }
    const widget = getWidgetFromEvent(e);
    if (widget) parseWidgetInfo(widget);
  };

  document.addEventListener('rebuy.beforeReady', logAndParse('beforeReady'));

  const addToCart = async (variantId, buttonElement) => {
    if (!variantId) {
      console.error('[Rebuy] No variant ID provided');
      return;
    }

    if (!buttonElement) return;

    const btnText = buttonElement.querySelector('.product-card__btn-text');
    const originalText = btnText ? btnText.innerHTML : '';

    buttonElement.setAttribute('aria-disabled', 'true');
    buttonElement.setAttribute('aria-busy', 'true');

    if (btnText) {
      btnText.innerHTML = '<span class="rebuy-loading-dots"><span></span><span></span><span></span></span>';
    }

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    };

    try {
      const response = await fetch('/cart/add.js', config);
      const parsedState = await response.json();

      if (parsedState.status) {
        console.error('[Rebuy] Add to cart error:', parsedState);
        if (window.theme && window.theme.pubsub) {
          window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartError, {
            source: 'rebuy-product-card',
            productVariantId: variantId,
            errors: parsedState.errors || parsedState.description,
            message: parsedState.message
          });
        }

        if (btnText) {
          btnText.innerHTML = originalText;
        }
        buttonElement.removeAttribute('aria-busy');
        buttonElement.removeAttribute('aria-disabled');
        return;
      }

      if (window.theme && window.theme.pubsub) {
        window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'rebuy-product-card',
          productVariantId: variantId,
        });
      }

      if (btnText) {
        btnText.innerHTML = originalText;
      }
      buttonElement.removeAttribute('aria-busy');
      buttonElement.removeAttribute('aria-disabled');

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.show) {
        cartDrawer.show(buttonElement);
      }
    } catch (error) {
      console.error('[Rebuy] Add to cart fetch error:', error);
      if (btnText) {
        btnText.innerHTML = originalText;
      }
      buttonElement.removeAttribute('aria-busy');
      buttonElement.removeAttribute('aria-disabled');
    }
  };

  const formatCountdown = (countdownStr) => {
    try {
      const date = new Date(countdownStr);
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const formattedDate = months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
      return formattedDate;
    } catch (e) {
      console.warn('[Rebuy] formatCountdown error:', e);
      return countdownStr;
    }
  };

  const normalizeUsdValue = (value) => {
    if (value == null || value === '') return 0;
    let num = typeof value === 'number' ? value : parseFloat(value);
    if (!Number.isFinite(num)) return 0;

    return num;
  };

  // Helper function to get Rebuy widget instance by widget ID
  const getRebuyWidget = (widgetId) => {
    if (!window.Rebuy || !window.Rebuy.widgets) return null;

    // Try to find widget by ID
    const widget = window.Rebuy.widgets.find(w => {
      if (w.id === widgetId) return true;
      if (w.data && w.data.id === widgetId) return true;
      if (w.widgetId === widgetId) return true;
      return false;
    });

    return widget || null;
  };

  const formatPriceWithRebuy = (value) => {
    try {
      const rebuyWidget = window.Rebuy?.widgets?.[0] || null;
      if (rebuyWidget?.View?.vue?.formatMoney) {
        return rebuyWidget.View.vue.formatMoney(value);
      }
    } catch (err) {
      debugLog('[Rebuy] formatPriceWithRebuy error:', err);
    }

    return null;
  };

  const formatPrice = (priceValue) => {
    // Try Rebuy API first
    const rebuyFormatted = formatPriceWithRebuy(priceValue);
    if (rebuyFormatted) {
      return rebuyFormatted;
    }

    // Fallback to old method if Rebuy functions are not available
    const rate = window.Shopify?.currency?.rate;
    return (priceValue * rate).toFixed(2);
  };

  const formatComparePriceValue = (compareValue, baseValue) => {
    const compareAmount = normalizeUsdValue(compareValue);
    const baseAmount = normalizeUsdValue(baseValue);
    if (!compareAmount || compareAmount <= baseAmount) {
      return '';
    }
    return formatPrice(compareValue) || '';
  };

  const buildVariantButton = (variant, href) => {
    if (!variant) return '';

    const variantTitle = variant.title || '';
    const variantPrice = formatPrice(variant?.price) || '';
    const variantCompareAt = formatComparePriceValue(variant?.compare_at_price, variant?.price);
    const variantId = variant?.id || '';
    const variantIdAttr = variantId ? `data-variant-id="${variantId}"` : '';

    const inventory = variant?.inventory_quantity ?? (variant?.inventory_management !== null ? 0 : null);
    const isSoldOut = inventory !== null && inventory === 0;

    if (isSoldOut) {
      const soldOutLabel = getTranslation('soldOut', 'SOLD OUT');
      return '<div class="button button--primary rebuy-sold-out-btn flex justify-center items-center w-full">' +
        '<div class="product-card__btn-text" style="font-weight: normal; display: flex; flex-direction: column; align-items: center; gap: 0.25rem;"><div style="font-size: 1rem;">' + variantTitle.replace(/</g, '&lt;') + '</div><div style="font-size: 1.1em; font-weight: 700;">' + soldOutLabel + '</div></div>' +
      '</div>';
    }

    const priceHtml = (variantPrice || variantCompareAt)
      ? '<div style="font-size: 0.9em;">' + (variantPrice ? '<span class="price__regular">' + variantPrice.replace(/</g, '&lt;') + '</span>' : '') + (variantCompareAt ? ' <span class="price__compare" style="font-size: 0.85em; margin-left: 4px;">' + variantCompareAt.replace(/</g, '&lt;') + '</span>' : '') + '</div>'
      : '';

    return '<button type="button" class="button button--primary hover-button animated-button rebuy-add-to-cart-btn flex justify-center items-center" ' + variantIdAttr + '>' +
      '<div class="product-card__btn-text" style="font-weight: normal; display: flex; flex-direction: column; align-items: center; gap: 0.1rem; font-size: 1rem;"><div>' + variantTitle.replace(/</g, '&lt;') + '</div>' + priceHtml + '</div>' +
    '</button>';
  };

  const buildFormattedCard = (blockEl, widgetId) => {
    let productId = null;
    const classList = Array.from(blockEl.classList || []);
    const productIdClass = classList.find(c => c.startsWith('product-id-'));
    if (productIdClass) {
      productId = productIdClass.replace('product-id-', '');
    } else {
      productId = blockEl.getAttribute('data-product-id') || blockEl.getAttribute('data-rebuy-product-id') || null;
    }

    const g = ensureGlobal();
    const widgetData = g.byWidgetId[widgetId] || {};
    const productMetadata = widgetData.classified?.find(p => String(p.id) === String(productId)) ||
                            widgetData.products?.find(p => String(p.id) === String(productId)) || null;

    debugLog(`[Rebuy] buildFormattedCard: ${widgetId} - ${productId}`, {
      widgetId,
      productId,
      blockClasses: blockEl.className,
      productMetadata: productMetadata,
      html: blockEl.innerHTML,
    });

    const mediaLink = blockEl.querySelector('.rebuy-product-media a');
    const mediaImg = blockEl.querySelector('.rebuy-product-media img');
    const titleLink = blockEl.querySelector('.rebuy-product-title-link');
    const priceElWithTabindex = blockEl.querySelector('.rebuy-product-price .rebuy-money [tabindex]');
    const priceEl = priceElWithTabindex || blockEl.querySelector('.rebuy-product-price .rebuy-money span:last-child');
    const addBtn = blockEl.querySelector('.rebuy-product-actions button');

    const href = mediaLink?.getAttribute('href') || titleLink?.getAttribute('href') || '#';
    const imgSrc = mediaImg?.getAttribute('src') || '';
    const imgAlt = mediaImg?.getAttribute('alt') || '';
    const title = titleLink?.textContent?.trim() || '';
    const vendor = productMetadata?.vendor || '';
    let price = priceEl?.textContent?.trim() || '';
    price = price.replace(/^Price\s+/i, '').trim();
    const comparePriceEl = blockEl.querySelector('.rebuy-product-price .price__compare');
    let comparePrice = comparePriceEl?.textContent?.trim() || '';
    comparePrice = comparePrice.replace(/^Compare\s+/i, '').trim();
    const btnText = addBtn?.textContent?.trim() || getTranslation('addToCart', 'Add to Cart');

    let buttonsHtml = '';
    let preOrderSoldOut = false;
    if (productMetadata?.classification === 'preowned-new' && productMetadata?.variants) {
      const preownedVariant = productMetadata.variants.find(v => v.title?.toUpperCase() === 'PRE-OWNED');
      const newVariant = productMetadata.variants.find(v => v.title?.toUpperCase() === 'NEW');

      const variantButtons = [];
      productMetadata.variants.forEach((variant) => {
        const variantTitleUpper = variant?.title?.toUpperCase() || '';
        if (variantTitleUpper === 'NEW' || variantTitleUpper === 'PRE-OWNED') {
          const variantHref = variant?.link || href;
          const buttonHtml = buildVariantButton(variant, variantHref);
          variantButtons.push(buttonHtml);
        }
      });

      buttonsHtml = '<div class="product-card__buttons flex justify-between flex-wrap gap-2 w-full" style="gap: 6px;">' +
        variantButtons.join('') +
      '</div>';
    } else if (productMetadata?.classification === 'two-variants' && productMetadata?.variants && productMetadata.variants.length === 2) {
      const variant1 = productMetadata.variants[0];
      const variant2 = productMetadata.variants[1];
      const variant1Title = variant1?.title || '';
      const variant2Title = variant2?.title || '';
      const variant1Price = formatPrice(variant1?.price) || '';
      const variant1CompareAt = formatComparePriceValue(variant1?.compare_at_price, variant1?.price);
      const variant2Price = formatPrice(variant2?.price) || '';
      const variant2CompareAt = formatComparePriceValue(variant2?.compare_at_price, variant2?.price);
      const variant1Href = variant1?.link || href;
      const variant2Href = variant2?.link || href;

      const variant1Inventory = variant1?.inventory_quantity ?? (variant1?.inventory_management !== null ? 0 : null);
      const variant2Inventory = variant2?.inventory_quantity ?? (variant2?.inventory_management !== null ? 0 : null);
      const variant1SoldOut = variant1Inventory !== null && variant1Inventory === 0;
      const variant2SoldOut = variant2Inventory !== null && variant2Inventory === 0;
      const bothSoldOut = variant1SoldOut && variant2SoldOut;

      if (bothSoldOut) {
        const soldOutLabel = getTranslation('soldOut', 'SOLD OUT');
        const variant1TitleEscaped = variant1Title.replace(/</g, '&lt;');
        const variant2TitleEscaped = variant2Title.replace(/</g, '&lt;');

        buttonsHtml = '<div class="product-card__buttons flex justify-between flex-wrap gap-2 w-full" style="gap: 6px;">' +
          '<div class="button button--primary rebuy-sold-out-btn flex justify-center items-center w-full">' +
            '<div class="product-card__btn-text" style="font-weight: normal; display: flex; flex-direction: column; align-items: center; gap: 0.25rem;"><div style="font-size: 0.85rem;">' + variant1TitleEscaped + '</div><div style="font-size: 1.1em; font-weight: 700;">' + soldOutLabel + '</div></div>' +
          '</div>' +
          '<div class="button button--primary rebuy-sold-out-btn flex justify-center items-center w-full">' +
            '<div class="product-card__btn-text" style="font-weight: normal; display: flex; flex-direction: column; align-items: center; gap: 0.25rem;"><div style="font-size: 0.85rem;">' + variant2TitleEscaped + '</div><div style="font-size: 1.1em; font-weight: 700;">' + soldOutLabel + '</div></div>' +
          '</div>' +
        '</div>';
      } else {
        let variant1Btn = '';
        const variant1Id = variant1?.id || '';
        const variant1IdAttr = variant1Id ? `data-variant-id="${variant1Id}"` : '';

        if (variant1SoldOut) {
          variant1Btn = '<div class="button button--primary rebuy-sold-out-btn flex justify-center items-center w-full">' +
            '<div class="product-card__btn-text" style="font-weight: normal; display: flex; flex-direction: column; align-items: center; gap: 0.25rem;"><div style="font-size: 0.85rem;">' + variant1Title.replace(/</g, '&lt;') + '</div><div style="font-size: 1.1em; font-weight: 700;">' + getTranslation('soldOut', 'SOLD OUT') + '</div></div>' +
          '</div>';
        } else {
          const variant1PriceHtml = (variant1Price || variant1CompareAt)
            ? '<div style="font-size: 1.1rem;">' + (variant1Price ? '<span class="price__regular">' + variant1Price.replace(/</g, '&lt;') + '</span>' : '') + (variant1CompareAt ? ' <span class="price__compare" style="font-size: 0.9em; margin-left: 4px;">' + variant1CompareAt.replace(/</g, '&lt;') + '</span>' : '') + '</div>'
            : '';
          variant1Btn = '<button type="button" class="button button--primary hover-button animated-button rebuy-add-to-cart-btn flex justify-center items-center" ' + variant1IdAttr + '>' +
            '<div class="product-card__btn-text" style="font-weight: normal; display: flex; flex-direction: column; align-items: center; gap: 0.1rem; font-size: 0.85rem;"><div>' + variant1Title.replace(/</g, '&lt;') + '</div>' + variant1PriceHtml + '</div>' +
          '</button>';
        }

        let variant2Btn = '';
        const variant2Id = variant2?.id || '';
        const variant2IdAttr = variant2Id ? `data-variant-id="${variant2Id}"` : '';

        if (variant2SoldOut) {
          variant2Btn = '<div class="button button--primary rebuy-sold-out-btn flex justify-center items-center w-full">' +
            '<div class="product-card__btn-text" style="font-weight: normal; display: flex; flex-direction: column; align-items: center; gap: 0.25rem;"><div style="font-size: 0.85rem;">' + variant2Title.replace(/</g, '&lt;') + '</div><div style="font-size: 1.1em; font-weight: 700;">' + getTranslation('soldOut', 'SOLD OUT') + '</div></div>' +
          '</div>';
        } else {
          const variant2PriceHtml = (variant2Price || variant2CompareAt)
            ? '<div style="font-size: 1.1rem;">' + (variant2Price ? '<span class="price__regular">' + variant2Price.replace(/</g, '&lt;') + '</span>' : '') + (variant2CompareAt ? ' <span class="price__compare" style="font-size: 0.9em; margin-left: 4px;">' + variant2CompareAt.replace(/</g, '&lt;') + '</span>' : '') + '</div>'
            : '';
          variant2Btn = '<button type="button" class="button button--primary hover-button animated-button rebuy-add-to-cart-btn flex justify-center items-center" ' + variant2IdAttr + '>' +
            '<div class="product-card__btn-text" style="font-weight: normal; display: flex; flex-direction: column; align-items: center; gap: 0.1rem; font-size: 0.85rem;"><div>' + variant2Title.replace(/</g, '&lt;') + '</div>' + variant2PriceHtml + '</div>' +
          '</button>';
        }

        buttonsHtml = '<div class="product-card__buttons flex justify-between flex-wrap gap-2 w-full" style="gap: 6px;">' +
          variant1Btn +
          variant2Btn +
        '</div>';
      }
    } else if (productMetadata?.classification === 'pre-order') {
      const selectedVariant = productMetadata.selected_variant || productMetadata.variants?.[0];
      const preOrderPrice = formatPrice(selectedVariant?.price) || '';
      const preOrderCompareAt = formatComparePriceValue(selectedVariant?.compare_at_price, selectedVariant?.price);
      const preOrderHref = selectedVariant?.link || href;
      const preOrderLabel = getTranslation('preOrder', 'PRE-ORDER').toUpperCase();

      const preOrderInventory = selectedVariant?.inventory_quantity ?? (selectedVariant?.inventory_management !== null ? 0 : null);
      preOrderSoldOut = preOrderInventory !== null && preOrderInventory === 0;

      let releaseDateHtml = '';
      const countdownValue = productMetadata?.metafields?.theme?.countdown;
      if (countdownValue != null && countdownValue !== '') {
        const formattedCountdown = formatCountdown(countdownValue);
        const countdownDisplay = String(formattedCountdown).replace(/</g, '&lt;');
        releaseDateHtml = '<div class="product-card__btn-text" style="text-align: center; font-size: 1rem;"><div style="font-size: 0.85rem;">' + getTranslation('release_date', 'RELEASE DATE') + '</div><div style="font-size: 1rem; font-weight: 700;">' + countdownDisplay + '</div></div>';
      } else {
        releaseDateHtml = '<div class="product-card__btn-text" style="text-align: center; font-size: 1rem;"><div style="font-size: 0.85rem;">' + getTranslation('release_date', 'RELEASE DATE') + '</div><div style="font-size: 1rem; font-weight: 700;">TBA</div></div>';
      }

      if (preOrderSoldOut) {
        buttonsHtml = '<div class="product-card__buttons flex justify-between flex-wrap gap-2 w-full" style="gap: 6px;">' +
          '<div class="button button--primary rebuy-sold-out-btn flex justify-center items-center w-full">' +
            '<div class="product-card__btn-text" style="font-weight: normal; display: flex; flex-direction: column; align-items: center; gap: 0.25rem;"><div style="font-size: 0.85rem;">' + preOrderLabel + '</div><div style="font-size: 1.1em; font-weight: 700;">' + getTranslation('soldOut', 'SOLD OUT') + '</div></div>' +
          '</div>' +
          '<div class="button button--primary rebuy-release-date-btn flex justify-center items-center w-full">' +
            releaseDateHtml +
          '</div>' +
        '</div>';
      } else {
        const preOrderPriceHtml = (preOrderPrice || preOrderCompareAt)
          ? '<div style="font-size: 1.1rem;">' + (preOrderPrice ? '<span class="price__regular">' + preOrderPrice.replace(/</g, '&lt;') + '</span>' : '') + (preOrderCompareAt ? ' <span class="price__compare" style="font-size: 0.9em; margin-left: 4px;">' + preOrderCompareAt.replace(/</g, '&lt;') + '</span>' : '') + '</div>'
          : '';
        buttonsHtml = '<div class="product-card__buttons flex justify-between flex-wrap gap-2 w-full" style="gap: 6px;">' +
          '<button type="button" class="button button--primary hover-button animated-button rebuy-add-to-cart-btn flex justify-center items-center" data-variant-id="' + (selectedVariant?.id || '') + '">' +
            '<div class="product-card__btn-text" style="font-weight: normal; display: flex; flex-direction: column; align-items: center; gap: 0.1rem; font-size: 0.85rem;"><div>' + preOrderLabel + '</div>' + preOrderPriceHtml + '</div>' +
          '</button>' +
          '<div class="button button--primary rebuy-release-date-btn flex justify-center items-center" style="width: 48.5%;">' +
            releaseDateHtml +
          '</div>' +
        '</div>';
      }
    } else {
      const isMultiple = productMetadata?.classification === 'multiple' ||
                         (productMetadata?.variants && productMetadata.variants.length > 2);

      let lowestPrice = '';
      if (isMultiple && productMetadata?.variants && productMetadata.variants.length > 0) {
        const prices = productMetadata.variants
          .map(v => normalizeUsdValue(v.price || v.compare_at_price || 0))
          .filter(p => p > 0);
        if (prices.length > 0) {
          const minPrice = Math.min(...prices);
          // For lowest price, use first variant or fallback
          const firstVariant = productMetadata?.variants?.[0];
          lowestPrice = formatPrice(minPrice) || '';
        }
      } else if (price) {
        const normalizedPrice = normalizeUsdValue(price);
        // For single price, use first variant or product metadata
        const firstVariant = productMetadata?.variants?.[0] || productMetadata?.selected_variant;
        lowestPrice = normalizedPrice ? (formatPrice(normalizedPrice) || price) : price;
      }

      if (isMultiple) {
        buttonsHtml = '<div class="product-card__buttons flex justify-between  flex-col  flex-wrap gap-2 w-full">' +
          '<a href="' + href + '" class="button button--primary hover-button animated-button flex justify-center items-center">' +
            '<div class="product-card__btn-text">' + getTranslation('view_details', 'View Detail') + (lowestPrice ? ' <span class="price__regular" style="margin-left:9px;">' + lowestPrice.replace(/</g, '&lt;') + '</span>' : '') + '</div>' +
          '</a>' +
        '</div>';
      } else {
        // Default: Add to Cart button with variant ID
        const selectedVariant = productMetadata?.selected_variant || productMetadata?.variants?.[0];
        const variantId = selectedVariant?.id || '';
        const variantIdAttr = variantId ? `data-variant-id="${variantId}"` : '';
        // Use Rebuy API to format price if available
        const variantPrice = formatPrice(selectedVariant?.price) || (price || '');
        const variantCompareAt = formatComparePriceValue(selectedVariant?.compare_at_price, selectedVariant?.price);

        buttonsHtml = '<div class="product-card__buttons flex justify-between  flex-col  flex-wrap gap-2 w-full">' +
          '<button type="button" class="button button--primary hover-button animated-button rebuy-add-to-cart-btn flex justify-center items-center w-full" ' + variantIdAttr + '>' +
            '<div class="product-card__btn-text">' + btnText.replace(/</g, '&lt;') + (variantPrice ? ' <span class="price__regular" style="margin-left:9px;">' + variantPrice.replace(/</g, '&lt;') + '</span>' : '') + (variantCompareAt ? ' <span class="price__compare" style="font-size: 0.9rem; margin-left: 4px;">' + variantCompareAt.replace(/</g, '&lt;') + '</span>' : '') + '</div>' +
          '</button>' +
        '</div>';
      }
    }

    const isPreOrder = productMetadata?.classification === 'pre-order';
    const isTwoVariantsBothSoldOut = productMetadata?.classification === 'two-variants' &&
                                      productMetadata?.variants &&
                                      productMetadata.variants.length === 2 &&
                                      (() => {
                                        const v1 = productMetadata.variants[0];
                                        const v2 = productMetadata.variants[1];
                                        const v1Inv = v1?.inventory_quantity ?? (v1?.inventory_management !== null ? 0 : null);
                                        const v2Inv = v2?.inventory_quantity ?? (v2?.inventory_management !== null ? 0 : null);
                                        const v1SoldOut = v1Inv !== null && v1Inv === 0;
                                        const v2SoldOut = v2Inv !== null && v2Inv === 0;
                                        return v1SoldOut && v2SoldOut;
                                      })();

    let cardClass = 'card product-card product-card--card flex flex-col leading-none relative';
    if (isPreOrder) {
      cardClass += ' rebuy-pre-order-card';
    } else if (isTwoVariantsBothSoldOut) {
      cardClass += ' rebuy-two-variants-sold-out-card';
    }

    // Check if product has NSFW content
    const isNsfw = productMetadata?.tags?.includes('Exclusive_18+');
    const nsfwThumbnailUrl = window.theme?.assets?.nsfwThumbnailUrl || '';

    let nsfwOverlayHtml = '';
    if (isNsfw && nsfwThumbnailUrl) {
      nsfwOverlayHtml = '<div class="nsfw-overlay absolute top-0 left-0 w-full h-full z-10 flex flex-col items-center justify-center cursor-pointer" ' +
        'onclick="event.preventDefault(); event.stopPropagation(); sessionStorage.setItem(\'nsfw_revealed\', \'true\'); document.documentElement.classList.add(\'nsfw-revealed\');">' +
        '<img src="' + nsfwThumbnailUrl + '" alt="NSFW Content" class="nsfw-overlay__image" width="200" height="133" loading="lazy">' +
      '</div>';
    }

    return (
      '<div class="' + cardClass + '">' +
        '<div class="product-card__media relative h-auto">' +
          '<a class="block relative media media--square" href="' + href + '" tabindex="-1">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="' + imgAlt.replace(/"/g, '&quot;') + '">' : '') +
          '</a>' +
          nsfwOverlayHtml +
        '</div>' +
        '<div class="product-card__content grow flex flex-col justify-between text-left">' +
          '<div class="product-card__top w-full"></div>' +
          '<div class="product-card__details flex flex-col items-baseline gap-2 w-full h-full">' +
            '<div class="product-card__title-wrapper grow">' +
              (vendor ? '<div class="product-card__vendor" style="color:#6b7280; font-size: 0.85em; margin-bottom: 2px;">' + String(vendor).replace(/</g, '&lt;') + '</div>' : '') +
              '<a class="product-card__title text-base-xl font-medium leading-tight" href="' + href + '">' + title.replace(/</g, '&lt;') + '</a>' +
            '</div>' +
            buttonsHtml +
          '</div>' +
        '</div>' +
      '</div>'
    );
  };

  const formatWidgetSlides = (widgetRootEl, id) => {
    const g = ensureGlobal();
    try {
      const list = widgetRootEl.querySelector('.rebuy-product-grid .splide__list');
      if (!list) return;
      const blocks = list.querySelectorAll('.rebuy-product-block');
      const formatted = [];
      blocks.forEach((b) => {
        if (b.getAttribute('data-formatted') === 'true') return;
        const html = buildFormattedCard(b, id);
        formatted.push(html);
        b.removeAttribute('style');
        b.innerHTML = html;
        b.setAttribute('data-formatted', 'true');

        const addToCartBtns = b.querySelectorAll('.rebuy-add-to-cart-btn');
        addToCartBtns.forEach((btn) => {
          const variantId = btn.getAttribute('data-variant-id');
          if (variantId) {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              addToCart(variantId, btn);
            });
          }
        });
      });
      g.byWidgetId[id] = { ...(g.byWidgetId[id] || {}), formattedCards: formatted };

      try {
        const track = widgetRootEl.querySelector('.rebuy-product-grid .splide__track');
        if (track) {
          track.style.setProperty('overflow-x', 'auto', 'important');
          track.style.setProperty('overflow-y', 'hidden', 'important');
          track.style.setProperty('-webkit-overflow-scrolling', 'touch');
          track.style.setProperty('touch-action', 'pan-x pan-y');
          track.style.setProperty('scroll-behavior', 'smooth');
          track.style.setProperty('scrollbar-width', 'none', 'important');
          track.style.setProperty('-ms-overflow-style', 'none', 'important');
        }
        const list = widgetRootEl.querySelector('.rebuy-product-grid .splide__list');
        if (list) {
          list.style.setProperty('display', 'flex', 'important');
          list.style.setProperty('flex-wrap', 'nowrap', 'important');
        }
      } catch (e) {
        console.warn('[Rebuy] enable scroll error:', e);
      }

      try {
        const splide = widgetRootEl.querySelector('.rebuy-product-grid.splide');
        const track = widgetRootEl.querySelector('.rebuy-product-grid .splide__track');
        let arrowsContainer = widgetRootEl.querySelector('.rebuy-product-grid .splide__arrows, .rebuy-product-grid .rebuy-carousel__arrows');
        let nextBtn = widgetRootEl.querySelector('.rebuy-product-grid .rebuy-carousel__arrow--next, .rebuy-product-grid .splide__arrow--next');
        let prevBtn = widgetRootEl.querySelector('.rebuy-product-grid .rebuy-carousel__arrow--prev, .rebuy-product-grid .splide__arrow--prev');

        if (track && splide) {
          const scrollStep = Math.max(0, Math.round(window.innerWidth * 0.4));
          const trackId = track.id || 'splide-track';

          if (!arrowsContainer) {
            arrowsContainer = document.createElement('div');
            arrowsContainer.className = 'splide__arrows rebuy-carousel__arrows splide__arrows--ltr';
            splide.appendChild(arrowsContainer);
          }

          if (!nextBtn) {
            nextBtn = document.createElement('button');
            nextBtn.className = 'splide__arrow rebuy-carousel__arrow splide__arrow--next rebuy-carousel__arrow--next';
            nextBtn.type = 'button';
            nextBtn.setAttribute('aria-label', 'Next slide');
            nextBtn.setAttribute('aria-controls', trackId);
            nextBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg>';
            arrowsContainer.appendChild(nextBtn);
          }

          if (!prevBtn) {
            prevBtn = document.createElement('button');
            prevBtn.className = 'splide__arrow rebuy-carousel__arrow splide__arrow--prev rebuy-carousel__arrow--prev';
            prevBtn.type = 'button';
            prevBtn.setAttribute('aria-label', 'Go to last slide');
            prevBtn.setAttribute('aria-controls', trackId);
            prevBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg>';
            arrowsContainer.insertBefore(prevBtn, nextBtn);
          }

          if (nextBtn) {
            const newNextBtn = nextBtn.cloneNode(true);
            nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);
            newNextBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              if (track) {
                const maxScroll = track.scrollWidth - track.clientWidth;
                const currentScroll = track.scrollLeft || 0;
                const newScroll = Math.min(currentScroll + scrollStep, maxScroll);
                track.scrollTo({ left: newScroll, behavior: 'smooth' });
              }
            }, { passive: false, capture: true });
          }

          if (prevBtn) {
            const newPrevBtn = prevBtn.cloneNode(true);
            prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
            newPrevBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              if (track) {
                const currentScroll = track.scrollLeft || 0;
                const newScroll = Math.max(0, currentScroll - scrollStep);
                track.scrollTo({ left: newScroll, behavior: 'smooth' });
              }
            }, { passive: false, capture: true });
          }
        }
      } catch (e) {
        console.warn('[Rebuy] custom arrow scroll error:', e);
      }

      widgetRootEl.style.display = 'block';
      widgetRootEl.removeAttribute('data-formatting');
    } catch (err) {
      console.error('[Rebuy] formatWidgetSlides error:', err);
      widgetRootEl.style.display = 'none';
      widgetRootEl.removeAttribute('data-formatting');
    }
  };

  const replacePrimaryTitleTag = (widgetRootEl) => {
    try {
      widgetRootEl.querySelectorAll('h4.primary-title, h3.primary-title').forEach((h4) => {
        const h2 = document.createElement('h2');
        h2.className = h4.className;
        h2.innerHTML = h4.innerHTML;
        if (h4.parentNode) h4.parentNode.replaceChild(h2, h4);
      });
    } catch (err) {
      debugLog('[Rebuy] replacePrimaryTitleTag error:', err);
    }
  };

  const applyComparePriceStyles = () => {
    try {
      const compareElements = document.querySelectorAll('.rebuy-widget.rebuy-custom-ui .product-card__buttons .price__compare');
      compareElements.forEach((el) => {
        el.style.setProperty('color', 'white', 'important');
      });

      const bundlePriceElements = document.querySelectorAll('.rebuy-custom-frequently-bought-together-ui .rebuy-bundle__actions-price span > span:nth-child(2)');
      bundlePriceElements.forEach((el) => {
        el.style.setProperty('color', '#fa4e70', 'important');
      });

      const bundleCompareAtElements = document.querySelectorAll('.rebuy-custom-frequently-bought-together-ui .rebuy-bundle__actions-price .compare-at span:nth-child(2)');
      bundleCompareAtElements.forEach((el) => {
        el.style.setProperty('color', '#ffffff', 'important');
      });

      const frequentlyBoughtMoneyElements = document.querySelectorAll('.rebuy-custom-frequently-bought-together-ui .rebuy-money');
      frequentlyBoughtMoneyElements.forEach((el) => {
        el.style.setProperty('color', '#fa4e70', 'important');
      });
      const frequentlyBoughtSinglePrice = document.querySelectorAll('.rebuy-custom-frequently-bought-together-ui .rebuy-bundle__actions-price-value .rebuy-money');
      frequentlyBoughtSinglePrice.forEach((el) => {
        const priceSpans = el.querySelectorAll('span:nth-child(2)');
        if (priceSpans.length === 1 && !el.classList.contains('sale') && !el.classList.contains('compare-at')) {
          priceSpans[0].style.setProperty('color', '#ffffff', 'important');
        }
      });

      const widgetMoneyElements = document.querySelectorAll('.rebuy-widget .rebuy-money');
      widgetMoneyElements.forEach((el) => {
        el.style.setProperty('color', '#fa4e70', 'important');
      });

      const bundleButtonElements = document.querySelectorAll('.rebuy-custom-frequently-bought-together-ui .rebuy-bundle .rebuy-bundle__actions .rebuy-button');
      bundleButtonElements.forEach((el) => {
        el.style.setProperty('background-color', '#fa4e70', 'important');
      });
    } catch (err) {
      console.error('[Rebuy] applyComparePriceStyles error:', err);
    }
  };

  const replaceMobileWidgetButtons = () => {
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    document.querySelectorAll('.widget-type-product .rebuy-button').forEach((button) => {
      if (button.dataset.mobileIconApplied === 'true') return;
      button.dataset.mobileIconApplied = 'true';
      button.innerHTML = `
        <svg class="icon icon-cart icon-sm md:hidden" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px;">
          <path stroke-miterlimit="10" d="M7.1802 7.58C7.1802 4.36 9.2402 1.75 11.7902 1.75C14.3402 1.75 16.4002 4.36 16.4002 7.58M11.7902 7.58C2.0402 7.58 0.690197 6.97 2.3502 16.18C3.3002 21.48 3.9802 22.22 11.7902 22.22C19.6002 22.22 20.2802 21.47 21.2302 16.18C22.8902 6.97 21.5502 7.58 11.7902 7.58Z"></path>
        </svg>
      `;
    });
  };

  const insertBundleTitleAndPriceBelowImages = () => {
    if (!document.body?.classList.contains('template-product')) return;

    document.querySelectorAll('.rebuy-bundle__image-item').forEach((imageItem) => {
      if (imageItem.querySelector('.injected-title') || imageItem.querySelector('.injected-price')) return;

      const img = imageItem.querySelector('img');
      if (!img) return;

      const productIdClass = Array.from(imageItem.parentElement?.classList || []).find((cls) => cls.startsWith('product-id-'));
      if (!productIdClass) return;

      const productId = productIdClass.replace('product-id-', '');
      const titleEl = document.querySelector(`.rebuy-product-block.product-id-${productId} .rebuy-product-title`);
      const priceEl = document.querySelector(`.rebuy-product-block.product-id-${productId} .rebuy-product-price`);
      if (!titleEl || !priceEl) return;

      const titleDiv = document.createElement('div');
      titleDiv.className = 'injected-title';
      titleDiv.textContent = titleEl.textContent.trim();
      titleDiv.style.marginTop = '8px';
      titleDiv.style.fontSize = '14px';
      titleDiv.style.color = '#333';
      titleDiv.style.textAlign = 'center';
      titleDiv.style.whiteSpace = 'normal';
      titleDiv.style.wordBreak = 'break-word';
      titleDiv.style.maxWidth = '100%';
      titleDiv.style.lineHeight = '1.4';
      titleDiv.style.display = 'block';

      const salePriceEl = priceEl.querySelector('.rebuy-money.sale span:last-child');
      const compareAtEl = priceEl.querySelector('.rebuy-money.compare-at span:last-child');
      const salePrice = salePriceEl ? salePriceEl.textContent.trim() : '';
      const compareAtPrice = compareAtEl ? compareAtEl.textContent.trim() : '';

      const priceDiv = document.createElement('div');
      priceDiv.className = 'injected-price';
      priceDiv.style.fontSize = '13px';
      priceDiv.style.color = '#666';
      priceDiv.style.textAlign = 'center';
      priceDiv.style.marginTop = '7px';
      priceDiv.style.marginBottom = '16px';
      priceDiv.style.display = 'block';

      if (salePrice && compareAtPrice && salePrice !== compareAtPrice) {
        const salePriceSpan = document.createElement('span');
        salePriceSpan.textContent = salePrice;
        salePriceSpan.style.color = 'red';
        salePriceSpan.style.fontWeight = '600';

        const compareAtSpan = document.createElement('span');
        compareAtSpan.textContent = compareAtPrice;
        compareAtSpan.style.textDecoration = 'line-through';
        compareAtSpan.style.marginLeft = '6px';
        compareAtSpan.style.color = '#999';

        priceDiv.append(salePriceSpan, compareAtSpan);
      } else if (salePrice) {
        priceDiv.textContent = salePrice;
      } else {
        priceEl.childNodes.forEach((child) => priceDiv.append(child.cloneNode(true)));
      }

      img.insertAdjacentElement('afterend', titleDiv);
      titleDiv.insertAdjacentElement('afterend', priceDiv);
    });
  };

  const startWidgetWatcher = () => {
    const g = ensureGlobal();
    if (g._widgetWatcher) {
      if (typeof g._scheduleWidgetScan === 'function') {
        g._scheduleWidgetScan();
      }
      return;
    }

    let scanQueued = false;

    const scan = () => {
      scanQueued = false;
      try {
        const nodes = document.querySelectorAll('.rebuy-widget[id^="rebuy-widget-"]');
        nodes.forEach((el) => {
          replacePrimaryTitleTag(el);
          const idAttr = el.getAttribute('id');
          if (!idAttr || !idAttr.startsWith('rebuy-widget-')) return;
          const id = idAttr.replace('rebuy-widget-', '');
          if (!g.allowedWidgetIds[id]) return;

          const html = typeof el.innerHTML === 'string' ? el.innerHTML : '';
          if (!id) return;
          const prev = g._lastHtml[id];
          if (html && html !== prev) {
            el.classList.add('rebuy-custom-ui');
            g.byWidgetId[id] = { ...(g.byWidgetId[id] || {}), html };
            g._lastHtml[id] = html;
            el.setAttribute('data-formatting', 'true');
            el.style.display = 'none';
            formatWidgetSlides(el, id);
            applyComparePriceStyles();
          }
        });
        replaceMobileWidgetButtons();
        insertBundleTitleAndPriceBelowImages();
      } catch (err) {
        console.error('[Rebuy] widget scan error:', err);
      }
    };

    const scheduleScan = () => {
      if (scanQueued) return;
      scanQueued = true;

      const run = () => scan();
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(run, { timeout: 500 });
      } else {
        window.requestAnimationFrame(run);
      }
    };

    g._scheduleWidgetScan = scheduleScan;
    scheduleScan();

    const observerRoot = document.querySelector('main') || document.body || document.documentElement;
    const observer = new MutationObserver(scheduleScan);
    observer.observe(observerRoot, { childList: true, subtree: true });
    g._widgetWatcher = observer;

    [
      'rebuy.beforeReady',
      'rebuy.ready',
      'rebuy:widget.ready',
      'rebuy:cart:change',
      'rebuy:smartcart.ready',
      'rebuy:smartcart.show'
    ].forEach((eventName) => {
      document.addEventListener(eventName, scheduleScan);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWidgetWatcher);
  } else {
    startWidgetWatcher();
  }
})();
